/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).ready(function(){
//   alert("hello");
//   $("#shipping-estimator-province").prop('selectedIndex', 1);
// });

// Wait for the DOM to fully load
document.addEventListener("DOMContentLoaded", function () {
  // Select the dropdown
  const selectState = document.getElementById("shipping-estimator-province");  
    selectState.selectedIndex = 1; // Index starts at 0
   // Alternatively, you can use value
  // Set the desired value
  //selectElement.value = "option2";
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll(".accordion-title");
  const accordionContents = document.querySelectorAll(".accordion-content");

  // Initially hide all accordion contents
  accordionContents.forEach(function (content) {
    content.style.display = "none";
  });

  accordionTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      // Close other accordions
      accordionTitles.forEach(function (otherTitle) {
        if (otherTitle !== title) {
          otherTitle.classList.remove("open");
          otherTitle.nextElementSibling.style.display = "none";
        }
      });

      // Toggle the clicked accordion
      const content = title.nextElementSibling;
      if (title.classList.contains("open")) {
        title.classList.remove("open");
        content.style.display = "none";
      } else {
        title.classList.add("open");
        content.style.display = "block";
      }
    });
  });
});



